<script>
import Gen from '@helper/Gen';
import BOGen from '@helper/BOGen';
import GlobalVue from '@helper/Global.vue';
import Config from '@config/Config.js';

import "@backend/dist/css/pages/login-register-lock.css"

export default {
  extends: GlobalVue,
  data(){
    return {
      input: {},
      mrValidation: {
        cwid: "required|maxlength:6",
        password: "required",
      },
    }
  },
  computed:{
    yearcopy(){
      return Gen.yearCopy(Config.yearcopy)
    }
  },
  mounted(){
    global.Page = this
    this.refreshVariable()
  },
  methods:{
    submit(e){
      if(e.btnLoading()) return;
      this.input.cwid = this.input.cwid.toUpperCase()
      BOGen.apirest("/auth", this.input, (err, resp)=>{
        if(err){
          e.btnUnloading()
          return Gen.info(err.json.message, 'danger')
        }
        
        this.$root.user = resp.user
        Gen.putCookie("user", resp.user)
        Gen.putCookie("botk", resp.token)
        Gen.info(`${resp.message}, Redirecting...`, 'success').then(()=>{
          if(this.$route.query.url) return this.$router.push({path:this.$route.query.url})
          this.$router.push({name:"Dashboard"})
          e.btnUnloading()
        })
      }, 'POST')
    },
  }
}
</script>

<template>
  <section id="wrapper">
    <div class="login-register p-0 d-flex align-items-center justify-content-center" style="background: #03a9f3;">
      <div class="login-box card">
        <div class="card-body">
          <VForm @resp="submit" class="form-horizontal form-material" id="loginform">
            <div class="text-center mb-4">
              <img :src="assets('images','bayer-logo.svg')" style="margin:0px auto 12px; display:block;width: 80px; height: 80px;" alt="Logo" />
              <h4 class="font-weight-bold">Employee Facility System</h4>
            </div>
            <div class="info"></div>
            <div class="form-group">
              <input class="form-control" name="cwid" type="text" v-model="input.cwid" v-bind="validation('cwid')" placeholder="CWID">
            </div>
            <div class="form-group">
              <input class="form-control" name="password" type="password" v-model="input.password" v-bind="validation('password')" placeholder="Password">
            </div>
            <div class="form-group text-center m-t-20">
              <button type="submit" class="btn btn-info btn-lg btn-block text-uppercase btn-rounded btn-loading">Login</button>
            </div>
          </VForm>
        </div>
      </div>
    </div>
  </section>
</template>